import { createAction } from 'redux-actions'

const prefix = 'GA/'

export const event = createAction(`${prefix}EVENT`)
export const exception = createAction(`${prefix}EXCEPTION`)
export const init = createAction(`${prefix}INIT`)
export const pageView = createAction(`${prefix}PAGE_VIEW`)
export const setOption = createAction(`${prefix}SET_OPTION`)
